import { HttpContextToken } from '@angular/common/http';

/**
 * Set this token to `true` on a request to prevent the global
 * error interceptor from redirecting to /error on failure.
 * The calling code is then responsible for handling the error itself.
 *
 * Usage:
 *   this.http.get(url, { context: new HttpContext().set(SKIP_ERROR_REDIRECT, true) })
 */
export const SKIP_ERROR_REDIRECT = new HttpContextToken<boolean>(() => false);
